import { useI18n } from "@/i18n/I18nContext";

const TONE = {
  atelier: "bg-amber-900/40 text-amber-100", testing: "bg-sky-900/40 text-sky-100", report: "bg-violet-900/40 text-violet-100",
  published: "bg-emerald-900/40 text-emerald-100", rejected: "bg-red-900/40 text-red-100", superseded: "bg-neutral-800 text-neutral-300",
};

export const StatusPill = ({ status, testId }) => {
  const { t } = useI18n();
  return <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${TONE[status] || TONE.superseded}`} data-testid={testId}>{t(`atelier.st.${status}`)}</span>;
};
